import PropTypes from 'prop-types';
import numeral from 'numeral';
import classNames from 'classnames';

const SelectedContactsString = ({ selected, results, label = 'constituents', additional_text, loading, className }) => {
  if (loading) return <div />;

  return (
    <div className={classNames(className, 'selected-contacts-string')}>
      {selected ? (
        <span>
          <strong>{numeral(selected).format('0,0')}</strong>
          <span> of </span>
        </span>
      ) : null}

      <strong>{numeral(results).format('0,0')}</strong>
      <span>
        {' '}
        {label} {selected ? 'selected' : ''}
      </span>

      {additional_text && <span>{additional_text}</span>}
    </div>
  );
};

SelectedContactsString.propTypes = {
  selected: PropTypes.number,
  results: PropTypes.number,
  label: PropTypes.string,
  additional_text: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

export default SelectedContactsString;
